import axios from "axios";
import { Client, IClient } from "@/shared/model/client.model";
import { IUser } from "@/shared/model/user-management/user.model";

const baseApiUrl = "api/company";

export default class CompanyService {
  public getAllClientsExceptManagersFromCompany(id?: number): Promise<Client[]> {
    let url = baseApiUrl;
    if (id) {
      url += "/client/" + id;
    }
    url += "/search/clients";
    return new Promise<Client[]>(function (resolve, reject) {
      axios
        .get(url)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public getAllClientsFromCompany(): Promise<IClient[]> {
    return new Promise<IClient[]>(function (resolve, reject) {
      axios
        .get(baseApiUrl + "/clients")
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public getAllManagersFromCompany(userToConvertId): Promise<IUser[]> {
    return new Promise<IUser[]>(function (resolve, reject) {
      axios
        .get(baseApiUrl + "/managers/"+userToConvertId)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public convertProspectToClient(idClient, idManager): Promise<Boolean> {
    return new Promise<Boolean>(function (resolve, reject) {
      axios
        .post(baseApiUrl + "/convert-prospect-to-client",idClient,idManager)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

}
